import i18n from '../utils/i18n';
import {
  CLEAR_NOTIFICATION,
  FETCH_HOME_FEED_FAILURE,
  DISPLAY_NOTIFICATION,
} from '../actions/types';

const initialState = {
  showNotification: false,
  message: null,
  type: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case DISPLAY_NOTIFICATION:
      return {
        showNotification: true,
        ...action.payload,
      };
    case FETCH_HOME_FEED_FAILURE:
      return {
        showNotification: true,
        message: i18n.gettext('global.notification.generic_error'),
        type: 'error',
      };
    case CLEAR_NOTIFICATION:
      return initialState;
    default:
      return state;
  }
};
